if (!customElements.get("m-announcement-bar")) {
  class MAnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const enableSlider = this.dataset.enableSlider === "true";
      this.initMarquees();
      if (enableSlider) this.initSlider();
    }

    initMarquees() {
      const contents = Array.from(this.querySelectorAll(".m-announcement-bar__content"));
      if (!contents.length) return;

      const update = () => {
        contents.forEach((content) => {
          const text = content.querySelector(".lmn-announcement-marquee__text");
          if (!text || content.clientWidth === 0) return;
          const overflowing = text.scrollWidth > content.clientWidth;
          content.classList.toggle("is-marquee", overflowing);
          if (overflowing) {
            content.style.setProperty("--lmn-marquee-duration", `${Math.max(12, text.scrollWidth / 28)}s`);
          } else {
            content.style.removeProperty("--lmn-marquee-duration");
          }
        });
      };

      requestAnimationFrame(update);
      setTimeout(update, 250);
      if (document.fonts?.ready) document.fonts.ready.then(update);
      if ("ResizeObserver" in window) {
        this.marqueeObserver = new ResizeObserver(update);
        contents.forEach((content) => this.marqueeObserver.observe(content));
      } else {
        window.addEventListener("resize", update, { passive: true });
      }
    }

    initSlider() {
      const autoplay = this.dataset.enableAutoplay === "true";
      const autoplaySpeed = this.dataset.autoplaySpeed;
      const slideContainer = this.querySelector(".swiper-container");
      if (slideContainer) {
        this.slider = new MinimogLibs.Swiper(slideContainer, {
          slidesPerView: 1,
          slidesPerGroup: 1,
          autoplay: autoplay
            ? {
                delay: parseInt(autoplaySpeed) * 1000,
              }
            : false,
          loop: true,
          navigation: {
            nextEl: this.querySelector(".swiper-button-next"),
            prevEl: this.querySelector(".swiper-button-prev"),
          },
        });
      }
    }
  }

  customElements.define("m-announcement-bar", MAnnouncementBar);
}
